import React, { memo } from 'react';
import { validators } from 'investira.sdk';

import { Stack, Typography, Card, Tooltip, Icon } from 'investira.react.components';
import { formats } from 'investira.sdk';

// < 0 -> o ativo rende menos que o titulo livre de risco.
// 0 a 1 -> desempenho baixo, mas positivo.
// 1 a 2 -> razoavel, considerado aceitavel.
// > 2 -> muito bom, indica forte retorno em relacao ao risco.

const SharpeCard = memo(props => {
  const {
    value = 0,
    label = 'Sharpe',
    tooltip,
    tooltipPosition = 'label',
    labelProps = {},
    valueProps = {},
    descriptionProps = {}
  } = props;

  const palette = pValue => {
    // Retorna a cor de acordo com o valor do Sharpe.
    if (pValue < 0) {
      return {
        backgroundColor: 'error.main',
        color: 'error.contrastText'
      };
    } else if (pValue >= 0 && pValue < 1) {
      return {
        backgroundColor: 'warning.main',
        color: 'background.dark'
      };
    } else if (pValue >= 1 && pValue < 2) {
      return {
        backgroundColor: 'info.highlight',
        color: 'info.contrastText'
      };
    } else if (pValue >= 2) {
      return {
        backgroundColor: 'primary.main',
        color: 'primary.contrastText'
      };
    }

    return {
      color: 'text.primary'
    };
  };

  const sharpeDescricao = pValue => {
    if (validators.isNull(pValue)) return 'Sem informação';
    if (pValue < 0) return 'Abaixo do risco livre';
    if (pValue >= 0 && pValue < 1) return 'Baixo retorno';
    if (pValue >= 1 && pValue < 2) return 'Retorno aceitável';
    if (pValue >= 2) return 'Ótimo retorno';
    return 'Sem classificação';
  };

  const xDescription = sharpeDescricao(value);
  const xShowLabelTooltip = tooltip && tooltipPosition === 'label';
  const xShowValueTooltip = tooltip && tooltipPosition === 'value';

  return (
    <Card
      sx={{
        flex: 1,
        display: 'flex',
        minHeight: 0,
        ...palette(value)
      }}>
      <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
        <Stack direction="row" justifyContent="space-between">
          <Typography
            variant="caption"
            color="inherit"
            {...labelProps}
            sx={{ fontWeight: 500, ...labelProps.sx }}>
            {label}
          </Typography>
          {xShowLabelTooltip && (
            <Tooltip title={tooltip}>
              <span>
                <Icon size={16} color={'inherit'} iconName="information" />
              </span>
            </Tooltip>
          )}
        </Stack>
        <Stack direction="column" justifyContent="flex-end">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant={{ xs: 'h6', xl: 'h5' }} color="inherit" {...valueProps}>
              <b>{!validators.isNull(value) ? formats.formatNumber(value, 3, true) : `---`}</b>
            </Typography>
            {xShowValueTooltip && (
              <Tooltip title={tooltip}>
                <span>
                  <Icon size={16} color={'inherit'} iconName="information" />
                </span>
              </Tooltip>
            )}
          </Stack>
          <Stack>
            <Typography
              variant={'caption'}
              color="inherit"
              {...descriptionProps}
              sx={{ fontWeight: 500, ...descriptionProps.sx }}>
              {xDescription}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
});

export default SharpeCard;
